import {getReportParams, report} from '../../../../../../middleware/report';

const getMessageActionType = (banFinanceIssueType) => {
  switch (banFinanceIssueType) {
    case 'NoPaymentMethod':
      return 'Update Pay Request Displayed';
    case 'DebtIssue':
      return 'Debt Pay Request Displayed';
    case 'NoPaymentMethodAndDebtIssue':
      return 'Update/Debt Request Displayed';
  }
};

const getClickActionType = (linkTypeClicked) => {
  switch (linkTypeClicked) {
    case 'NoPaymentMethod':
      return 'Update Payment Link Clicked';
    case 'DebtIssue':
      return 'Debt Payment Link Clicked';
  }
};

export const insertMessageToReport = (FinanceIssueType) => {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Financial Message';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = getMessageActionType(FinanceIssueType);
  reportParams.status = 'Ongoing';
  reportParams.messageText = getMessageActionType(FinanceIssueType);
  report(reportParams);
};

export const insertClickToReport = (buttonType) => {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Financial Message';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = getClickActionType(buttonType);
  reportParams.status = 'Completed';
  reportParams.messageText = getClickActionType(buttonType);
  report(reportParams);
};
